// DS: i12.1
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioProducts: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M5.82 3.5c-.4 0-.76.22-.94.58L3.1 7.55c-.07.14-.11.3-.11.47v.86a3.62 3.62 0 0 0 1.57 2.98v6.82c0 .42.19.74.34.94a3.55 3.55 0 0 0 1.24.85 1 1 0 0 0 .28.03h11.13c1.01 0 1.87-.8 1.87-1.82v-6.81A3.7 3.7 0 0 0 21 8.88v-.86c0-.17-.04-.33-.11-.47l-1.77-3.47a1.06 1.06 0 0 0-.94-.58zm11.6 9.03h-.13c-.98 0-1.92-.38-2.62-1.07l-.02-.02-.03.02a3.74 3.74 0 0 1-5.24 0l-.03-.02-.02.02a3.74 3.74 0 0 1-2.76 1.07v5.94l.1.06h10.76v-6ZM10.9 10a1.6 1.6 0 0 0 1.15.44h.03c.97 0 1.76-.78 1.76-1.74h1.77c0 .52.23.98.59 1.3a1.6 1.6 0 0 0 1.15.44h.02c.98 0 1.77-.78 1.77-1.74a1.74 1.74 0 0 0-.31-.98l-.4-.65h.01l-.9-1.61H6.43l-.74 1.5-.42.82c-.05.08-.1.17-.14.27l-.04.1a1.71 1.71 0 0 0 .5 1.85 1.6 1.6 0 0 0 1.15.44h.02c.98 0 1.77-.78 1.77-1.74h1.76c0 .52.23.98.6 1.3Z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
StudioProducts.displayName = 'StudioProducts';

export default StudioProducts;
